import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import { VIEWER_CORE_SERVICES_APP_DEFINITION_ID, VIEWER_SERVICE_EXTENSION_NAME } from '@wix/thunderbolt-commons'
import type { BuilderPublicClientSpecEntry } from '@wix/thunderbolt-ssr-api'

const externalServicesSiteConfig: SiteConfigFn<Record<string, never>> = ({ api }) => {
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}

	let hasExternalServices = false
	for (const app of Object.values(clientSpecMap)) {
		const typedApp = app as BuilderPublicClientSpecEntry
		if (typedApp.appDefinitionId === VIEWER_CORE_SERVICES_APP_DEFINITION_ID) {
			continue
		}
		const components = typedApp.components || []
		for (const component of components) {
			if (component.type === VIEWER_SERVICE_EXTENSION_NAME) {
				hasExternalServices = true
				break
			}
		}
		if (hasExternalServices) {
			break
		}
	}

	if (!hasExternalServices) {
		return { shouldLoadSiteFeature: false }
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'externalServices'

export const config = { site: externalServicesSiteConfig, name }
